<template>
  <div class="animated fadeIn bgV2">
    <b-row>
      <b-col md="12">
        <gofix-tab
                class="mt-3"
                :data="tabData">
          <template slot="gofixTab:right" v-if=" $checkRole($accessModule.order, 'update')">
            <gofix-button
                    label="Save"
                    @click="updateKPI"
                    :loading="isAction"></gofix-button>
          </template>
          <template slot="gofixTab:basic-info">
            <gofix-card title="Actual">
              <b-form>
                <b-row>
                  <b-col md="2">
                    <gofix-form-input-date
                            desc="dd.mm.yyyy"
                            v-model="case_reported.case_reported_date"
                            :disabled="true"
                            label="Case Reported Date">
                    </gofix-form-input-date>
                  </b-col>
                  <b-col md="2">
                    <gofix-form-input-time :disabled="true" label="Case Reported Time" desc="hh:mm" v-model="case_reported.case_reported_time"></gofix-form-input-time>
                  </b-col>
                  <b-col md="2">
                    <gofix-form-input-date
                            desc="dd.mm.yyyy"
                            v-model="case_ack_actual.case_ack_actual_date"
                            label="Case Acknowledged Date">
                    </gofix-form-input-date>
                  </b-col>
                  <b-col md="2">
                    <gofix-form-input-time label="Case Acknowledged Time" desc="hh:mm" v-model="case_ack_actual.case_ack_actual_time"></gofix-form-input-time>
                  </b-col>
                  <b-col md="2">
                    <gofix-form-input-date
                            desc="dd.mm.yyyy"
                            v-model="case_onsite_actual.case_onsite_actual_date"
                            label="First time On Site Date">
                    </gofix-form-input-date>
                  </b-col>
                  <b-col md="2">
                    <gofix-form-input-time label="First time On Site Time" desc="hh:mm" v-model="case_onsite_actual.case_onsite_actual_time"></gofix-form-input-time>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="2">
                    <gofix-form-input-date
                            desc="dd.mm.yyyy"
                            v-model="wo_complete_actual.wo_complete_actual_date"
                            label="WO Completed Date">
                    </gofix-form-input-date>
                  </b-col>
                  <b-col md="2">
                    <gofix-form-input-time label="WO Completed Time" desc="hh:mm" v-model="wo_complete_actual.wo_complete_actual_time"></gofix-form-input-time>
                  </b-col>
                  <b-col md="2">
                    <gofix-form-input-date
                            desc="dd.mm.yyyy"
                            v-model="admin_start_actual.admin_start_actual_date"
                            label="AP Invoice Recieved Date">
                    </gofix-form-input-date>
                  </b-col>
                  <b-col md="2">
                    <gofix-form-input-time label="AP Invoice Recieved Time" desc="hh:mm" v-model="admin_start_actual.admin_start_actual_time"></gofix-form-input-time>
                  </b-col>
                  <b-col md="2">
                    <gofix-form-input-date
                            desc="dd.mm.yyyy"
                            v-model="admin_start_actual.admin_closure_actual_date"
                            label="Payment Made Date">
                    </gofix-form-input-date>
                  </b-col>
                  <b-col md="2">
                    <gofix-form-input-time label="Payment Made Time" desc="hh:mm" v-model="admin_closure_actual.admin_closure_actual_time"></gofix-form-input-time>
                  </b-col>
                </b-row>
              </b-form>
            </gofix-card>
          </template>
        </gofix-tab>
      </b-col>
    </b-row>
  </div>

</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
export default {
  name: 'edit-kpi-target',
  components: {},
  data () {
    return {
      tabData:[
        {
          key: "basic-info",
          title: "Basic Info",
          active: true
        },
      ],
      mode: 'single',
      formats: {
        input: ['DD.MM.YYYY'],
      },
      isAction : false,
      case_reported : {
          case_reported_date : null,
          case_reported_time : null,
      },
      case_ack_actual : {
          case_ack_actual_date : null,
          case_ack_actual_time : null,
      },
      case_onsite_actual : {
          case_onsite_actual_date : null,
          case_onsite_actual_time : null,
      },
      wo_complete_actual : {
          wo_complete_actual_date : null,
          wo_complete_actual_time : null,
      },
      admin_start_actual : {
          admin_start_actual_date : null,
          admin_start_actual_time : null,
      },
      admin_closure_actual : {
          admin_closure_actual_date : null,
          admin_closure_actual_time : null,
      },
    }
  },
  created(){
    this.id = this.$route.params.id;
    if(!this.Order)
      this.$store.dispatch("OrderController/getItem",this.id)
    else {
      this.setData(this.Order.kpi);
    }

  },
    watch: {
      Order: function(val, old) {
          if(val){
              this.setData(val.kpi);
          }
      },
  },
  computed: {
      ...mapGetters({
          Order: 'OrderController/Item',
      }),
  },
  methods: {
    updateKPI(){


      if(this.case_reported.case_reported_date){
        var case_reported = moment(this.case_reported.case_reported_date).format('YYYY-MM-DD');
        if(this.case_reported.case_reported_time)
          case_reported = case_reported +' '+ this.case_reported.case_reported_time+':00';
        else case_reported = case_reported +' '+'00:00:00';

      }


      if(this.case_ack_actual.case_ack_actual_date){
        var case_ack_actual = moment(this.case_ack_actual.case_ack_actual_date).format('YYYY-MM-DD');
        if(this.case_ack_actual.case_ack_actual_time)
          case_ack_actual = case_ack_actual +' '+ this.case_ack_actual.case_ack_actual_time+':00';
        else case_ack_actual = case_ack_actual +' '+'00:00:00';
      }
      if(this.case_onsite_actual.case_onsite_actual_date){
        var case_onsite_actual =  moment(this.case_onsite_actual.case_onsite_actual_date).format('YYYY-MM-DD');
        if(this.case_onsite_actual.case_onsite_actual_time)
          case_onsite_actual = case_onsite_actual +' '+ this.case_onsite_actual.case_onsite_actual_time+':00';
        else case_onsite_actual = case_onsite_actual +' '+'00:00:00';
      }


      if(this.wo_complete_actual.wo_complete_actual_date){
        var wo_complete_actual =  moment(this.wo_complete_actual.wo_complete_actual_date).format('YYYY-MM-DD');
        if(this.wo_complete_actual.wo_complete_actual_time)
          wo_complete_actual =  wo_complete_actual +' '+ this.wo_complete_actual.wo_complete_actual_time+':00';
        else wo_complete_actual =  wo_complete_actual +' '+'00:00:00';
      }
      if(this.admin_start_actual.admin_start_actual_date){
        var admin_start_actual =  moment(this.admin_start_actual.admin_start_actual_date).format('YYYY-MM-DD');
        if(this.admin_start_actual.admin_start_actual_time)
          admin_start_actual =  admin_start_actual +' '+ this.admin_start_actual.admin_start_actual_time+':00';
        else admin_start_actual =  admin_start_actual +' '+'00:00:00';
      }
      if(this.admin_closure_actual.admin_closure_actual_date){
        var admin_closure_actual =  moment(this.admin_closure_actual.admin_closure_actual_date).format('YYYY-MM-DD');
        if(this.admin_closure_actual.admin_closure_actual_time)
          admin_closure_actual =  admin_closure_actual +' '+ this.admin_closure_actual.admin_closure_actual_time+':00';
        else admin_closure_actual =  admin_closure_actual +' '+'00:00:00';
      }

      if(moment(case_ack_actual).isBefore(case_reported) || moment(case_onsite_actual).isBefore(case_reported) || moment(wo_complete_actual).isBefore(case_reported) || moment(admin_start_actual).isBefore(case_reported) || moment(admin_closure_actual).isBefore(case_reported)) {
          return this.$bvToast.toast('The Date must be greater than the reported case date', {
              title: `Notification`,
              autoHideDelay: 3000,
              variant: 'danger',
              solid: true
          })
      }
      if(!this.case_reported.case_reported_date)
        return this.$bvToast.toast('Case reported required', {
            title: `Notification`,
            autoHideDelay: 3000,
            variant: 'danger',
            solid: true
        })
      this.isAction = true;
      this.$store.dispatch("KpiTargetController/updateKPIActual",{ id : this.Order.kpi.id ,  data : { case_reported :case_reported,case_ack_actual : case_ack_actual, case_onsite_actual : case_onsite_actual, wo_complete_actual : wo_complete_actual,admin_start_actual : admin_start_actual,admin_closure_actual : admin_closure_actual   }})
      .then(response => {
        this.isAction = false;
        return this.$bvToast.toast('Update KPI successfully', {
                title: `Notification`,
                autoHideDelay: 3000,
                variant: 'success',
                solid: true
              })
      })
      .catch(err => {})


    },
    setData(kpi){

      if(kpi.case_reported){
        this.case_reported.case_reported_date = new Date(kpi.case_reported)
        this.case_reported.case_reported_time = moment(kpi.case_reported).format('HH:mm')
      }
      if(kpi.case_ack_actual){
        this.case_ack_actual.case_ack_actual_date = new Date(kpi.case_ack_actual)
        this.case_ack_actual.case_ack_actual_time = moment(kpi.case_ack_actual).format('HH:mm')
      }
      if(kpi.case_onsite_actual){
        this.case_onsite_actual.case_onsite_actual_date = new Date( kpi.case_onsite_actual )
        this.case_onsite_actual.case_onsite_actual_time = moment(kpi.case_onsite_actual).format('HH:mm')
      }
      if(kpi.wo_complete_actual){
        this.wo_complete_actual.wo_complete_actual_date = new Date( kpi.wo_complete_actual)
        this.wo_complete_actual.wo_complete_actual_time = moment(kpi.wo_complete_actual).format('HH:mm')
      }
      if(kpi.admin_start_actual){
        this.admin_start_actual.admin_start_actual_date = new Date( kpi.admin_start_actual)
        this.admin_start_actual.admin_start_actual_time = moment(kpi.admin_start_actual).format('HH:mm')
      }
      if(kpi.admin_closure_actual){
        this.admin_closure_actual.admin_closure_actual_date = new Date( kpi.admin_closure_actual)
        this.admin_closure_actual.admin_closure_actual_time = moment(kpi.admin_closure_actual).format('HH:mm')
      }
    }
  }
}
</script>
